// datatable related plugins
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
  REGISTRY_INVOICE_FIELD,
} from "constants/FormatDataContanst";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import { TYPE_INVOICE } from "pages/ReportInvoiceError/helper/functionHelper";
import React, { useEffect, useState } from "react";
import { customFilter, textFilter } from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Badge, Card, CardBody, Col, Row } from "reactstrap";
import { resetSetBuStoreHeader } from "store/actions";
import {
  SET_BU_STORE_HEADER,
  SET_BU_STORE_HEADER_SUCCESS,
} from "store/dashboard/actionTypes";
import {
  getReportInvoiceList,
  resetDownloadReportInvoice,
  resetReportInvoiceList,
  setColumnVisibleReportInvoiceList,
} from "store/summary-invoice-data/actions";
import {
  DOWNLOAD_REPORT_INVOICE_FAIL,
  DOWNLOAD_REPORT_INVOICE_SUCCESS,
} from "store/summary-invoice-data/actionTypes";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DetailInvoice from "./DetailInvoice";
import { getInvoiceStatus } from "./helper/functionHelper";
import PDFViewModal from "./modal/PDFViewModal";
import { issueInvoiceModeList, issueInvoicePageViewList } from "./utils";
const ListAdjust = props => {
  // modalPDFView
  const [modalPdfView, setModalPdfView] = useState(false);
  const [dataViewDocument, setDataViewDocument] = useState(null);
  const togglePdfViewModal = () => setModalPdfView(!modalPdfView);

  const [dataDetail, setDataDetail] = useState({});
  const [detailModal, setDetailModal] = useState(false);
  const toggleDetailModal = () => {
    setDetailModal(!detailModal);
  };

  const [mode, setMode] = useState("");
  const [pageView, setPageView] = useState(null);

  const { addToast } = useToasts();

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  // store reducer
  const summaryInvoiceData = useSelector(state => state.summaryInvoiceData);
  const { type, fileDownload, fileDownloadName } = summaryInvoiceData;
  const { loading, listData, totalCount, columnsVisible, params } =
    summaryInvoiceData.reportInvoiceList;
  const history = useHistory();

  const { t, i18n } = useTranslation(["issueInvoice"]);

  const [commonStatus, setCommonStatus] = useState(getInvoiceStatus(t));

  useEffect(() => {
    setCommonStatus(getInvoiceStatus(t));
  }, [t]);

  useEffect(() => {
    initColumn();
  }, [commonStatus]);

  useEffect(() => {
    switch (type) {
      case DOWNLOAD_REPORT_INVOICE_SUCCESS: {
        if (fileDownload !== null) {
          const link = document.createElement("a");
          link.href = fileDownload;
          link.setAttribute("download", fileDownloadName);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        break;
      }
      case DOWNLOAD_REPORT_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        break;
    }
  }, [type]);

  const showPdfById = id => {
    setDataViewDocument({
      id,
    });
    togglePdfViewModal();
  };

  //   useEffect(() => {
  //     switch (type) {
  //       case RELEASE_INVOICE_CYCLES_SUCCESS:
  //         addToast("Gửi phát hành bảng tổng hợp dữ liệu thành công", {
  //           appearance: "success",
  //           autoDismiss: true,
  //         });
  //         toggleHSMSignModal();
  //         dispatch(getReportInvoiceList(params));
  //         dispatch(resetReleaseInvoiceCycles());
  //         break;
  //       case RELEASE_INVOICE_CYCLES_FAIL:
  //         addToast("Gửi phát hành bảng tổng hợp dữ liệu thất bại", {
  //           appearance: "error",
  //           autoDismiss: true,
  //         });
  //         dispatch(resetReleaseInvoiceCycles());
  //         break;
  //     }
  //   }, [type]);

  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader, finalBuInfo, type: typeDashboard } = Dashboard;

  // Action list chang tenantCode
  const [isCheckChangeStore, setIsCheckChangeStore] = useState(false);
  useEffect(() => {
    if (typeDashboard === SET_BU_STORE_HEADER) {
      setIsCheckChangeStore(true);
    }
    if (typeDashboard === SET_BU_STORE_HEADER_SUCCESS && isCheckChangeStore) {
      params.page = 1;
      dispatch(getReportInvoiceList(params, TYPE_INVOICE.ADJUST));
      dispatch(resetSetBuStoreHeader());
    }
  }, [typeDashboard]);

  useEffect(() => {
    initColumn();
    return () => {
      dispatch(resetReportInvoiceList());
    };
  }, []);

  const initColumn = () => {
    if (Object.keys(columnsVisible).length !== 0) {
      for (const item of initColumns) {
        if (columnsVisible[item.dataField] !== undefined) {
          item.hidden = !columnsVisible[item.dataField];
        }
      }
    }
    setColumns(initColumns);
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      //   setDataDetail(row);
      //   toggleViewDetailModal();
    },
  };

  const listRowAction = [
    // {
    //   icon: <i className="bx bx-download font-size-18 text-primary" />,
    //   text: "Download file",
    //   conditionVisible: {
    //     resource_id: [],
    //   },
    // },
  ];

  const OPTION_HTHUC = [
    {
      value: REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.ADD,
      label: t("select.hthuc_add"),
    },
    {
      value: REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.EDIT,
      label: t("select.hthuc_edit"),
    },
  ];

  const selectFilterHTHUC = {
    [REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.ADD]:
      t("select.hthuc_add"),
    [REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.EDIT]:
      t("select.hthuc_edit"),
  };

  const getAuthStatus = (status, id) => {
    let infoError = null;
    if (
      status === AUTH_STATUS_REJECT ||
      status === AUTH_STATUS_RRE ||
      status === AUTH_STATUS_RR
    ) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setIdRelease(id);
            toggleErrorReleaseModal();
          }}
        ></i>
      );
    }
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[status]?.text}
          </Badge>
          {infoError}
        </div>
      </React.Fragment>
    );
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Đang xử lý",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Hoàn tất",
  };

  const initColumns = [
    {
      dataField: "root_id",
      text: "Id",
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "75px" },
      }),
      formatter: (cellContent, row) => (
        <div style={{ maxWidth: "115px", whiteSpace: "initial" }}>
          {cellContent ? cellContent : "(Hóa đơn TT32)"}
        </div>
      ),
      headerStyle: {
        color: "red",
      },
    },
    {
      dataField: "root_khhdon",
      text: "Ký hiệu",
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "75px" },
      }),
      formatter: (cellContent, row) => {
        if (cellContent) {
          return String(row?.root_khmshdon) + String(row?.root_khhdon);
        } else {
          return "";
        }
      },
      headerStyle: {
        color: "red",
      },
    },
    {
      dataField: "root_shdon",
      text: "Số hóa đơn",
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "75px" },
      }),
      formatter: (cellContent, row) => (
        <div style={{ maxWidth: "115px", whiteSpace: "initial" }}>
          {cellContent ? cellContent : "Chờ cấp số"}
        </div>
      ),
      headerStyle: {
        color: "red",
      },
    },
    {
      dataField: "root_nlap",
      text: "Ngày lập",
      formatter: (cellContent, row) =>
        tableFormateDate(cellContent, false, true),
      headerStyle: {
        color: "red",
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
    // {
    //   dataField: "root_note",
    //   text: "Ghi chú",
    //   formatter: (cellContent, row) => (
    //     <div style={{ maxWidth: "115px", whiteSpace: "initial" }}>
    //       {cellContent}
    //     </div>
    //   ),
    //   headerStyle: {
    //     color: "red",
    //   },
    // },
    {
      dataField: "action_1",
      text: "",
      formatter: (cellContent, row) => {
        if (row.root_id) {
          return (
            <div className="d-flex gap-2 justify-content-center">
              <i
                onClick={() => {
                  showDetailById(row.root_id, row.root_khmshdon);
                }}
                title="Chi tiết hóa đơn"
                style={{ cursor: "pointer", fontSize: "26px" }}
                className="text-info bx bx-message-square-dots label-icon"
              />
              <i
                onClick={() => {
                  showPdfById(row.root_id);
                }}
                title="Bản hiển thị"
                style={{ cursor: "pointer", fontSize: "26px" }}
                className="text-danger bx bxs-file-pdf label-icon"
              />
            </div>
          );
        }
      },
    },
    {
      dataField: "child_id",
      text: "Id",
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "75px" },
      }),
      formatter: (cellContent, row) => (
        <div style={{ maxWidth: "115px", whiteSpace: "initial" }}>
          {cellContent ? cellContent : "(Hóa đơn TT32)"}
        </div>
      ),
      headerStyle: {
        color: "blue",
      },
    },
    {
      dataField: "child_khhdon",
      text: "Ký hiệu",
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "75px" },
      }),
      formatter: (cellContent, row) => {
        if (cellContent) {
          return String(row?.child_khmshdon) + String(row?.child_khhdon);
        } else {
          return "";
        }
      },
      headerStyle: {
        color: "blue",
      },
    },
    {
      dataField: "child_shdon",
      text: "Số hóa đơn",
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "75px" },
      }),
      formatter: (cellContent, row) => (
        <div style={{ maxWidth: "115px", whiteSpace: "initial" }}>
          {cellContent ? cellContent : "Chờ cấp số"}
        </div>
      ),
      headerStyle: {
        color: "blue",
      },
    },
    {
      dataField: "child_nlap",
      text: "Ngày lập",
      formatter: (cellContent, row) =>
        tableFormateDate(cellContent, false, true),
      headerStyle: {
        color: "blue",
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
    // {
    //   dataField: "child_note",
    //   text: "Ghi chú",
    //   formatter: (cellContent, row) => (
    //     <div style={{ maxWidth: "115px", whiteSpace: "initial" }}>
    //       {cellContent}
    //     </div>
    //   ),
    //   headerStyle: {
    //     color: "blue",
    //   },
    // },
    {
      dataField: "action_2",
      text: "",
      formatter: (cellContent, row) => {
        if (row.child_id) {
          return (
            <div className="d-flex gap-2 justify-content-center">
              <i
                onClick={() => {
                  showDetailById(row.child_id, row.child_khmshdon);
                }}
                title="Chi tiết hóa đơn"
                style={{ cursor: "pointer", fontSize: "26px" }}
                className="text-info bx bx-message-square-dots label-icon"
              />
              <i
                onClick={() => {
                  showPdfById(row.child_id);
                }}
                title="Bản hiển thị"
                style={{ cursor: "pointer", fontSize: "26px" }}
                className="text-danger bx bxs-file-pdf label-icon"
              />
            </div>
          );
        }
      },
    },
  ];

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.columnFilter = columnFilter;
    params.page = page;
    params.sizePerPage = sizePerPage;
    dispatch(getReportInvoiceList(params, TYPE_INVOICE.ADJUST));
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    dispatch(getReportInvoiceList(params, TYPE_INVOICE.ADJUST));
  };

  const optionShowColumnHandel = (field, value) => {
    const targetColumn = columns.find(item => item.dataField === field);
    if (targetColumn) {
      targetColumn.hidden = !value;
    }
    setColumns(columns);
    dispatch(setColumnVisibleReportInvoiceList(field, value));
  };

  const resetDataFunc = () => {
    dispatch(getReportInvoiceList(params, TYPE_INVOICE.ADJUST));
  };

  const showDetailById = (id, khmshdon) => {
    //   getListInvoiceSymbol(row.ttchung_khmshdon);
    //   setDataConfirmAction({
    //     typeAdjust: row.adjust_mod,
    //   });
    setDataDetail({
      id: id,
    });
    switch (khmshdon) {
      case "1":
        setPageView(issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE);
        setMode(issueInvoiceModeList.VIEW_VAT_INVOICE_DETAIL);
        break;
      case "2":
        setPageView(issueInvoicePageViewList.PAGE_SALE_INVOICE_HAVE_CODE);
        setMode(issueInvoiceModeList.VIEW_SALE_INVOICE_DETAIL);
        break;
      default:
        break;
    }
    toggleDetailModal();
  };

  const CaptionElement = (
    <div
      style={{
        textAlign: "center",
        border: "2px solid #eff2f7",
        borderBottom: "none",
        fontSize: "20px",
        display: "flex",
      }}
    >
      <div
        style={{
          color: "red",
          width: "50%",
          padding: "0.5em",
          borderRight: "2px solid #eff2f7",
        }}
      >
        Hóa đơn bị điều chỉnh
      </div>
      <div style={{ color: "blue", width: "50%", padding: "0.5em" }}>
        Hóa đơn điều chỉnh
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Danh sách hóa đơn điều chỉnh</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title=""
            breadcrumbItem={"Danh sách hóa đơn điều chỉnh" + ` (${totalCount})`}
          />
          <Row>
            {/* Detail Modal */}
            <DetailInvoice
              dataDetail={dataDetail}
              //   dataConfirmAction={dataConfirmAction}
              isOpenModal={detailModal}
              toggleModal={toggleDetailModal}
              showPdfById={showPdfById}
              mode={mode}
              pageView={pageView}
            />
            {/* PDFViewModal */}
            <PDFViewModal
              isOpen={modalPdfView}
              dataViewDocument={dataViewDocument}
              toggle={togglePdfViewModal}
            ></PDFViewModal>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <React.Fragment>
                    <RemoteDataTable
                      caption={CaptionElement}
                      keyField="id"
                      data={listData}
                      columns={columns}
                      page={params.page}
                      listRowAction={listRowAction}
                      sizePerPage={params.sizePerPage}
                      totalSize={totalCount}
                      loading={loading}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandel}
                      rowEvents={rowEvents}
                    ></RemoteDataTable>
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListAdjust;
